var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"home-nestle-top"}},[_c('div',{staticClass:"nestle-home-logos"},[_c('img',{attrs:{"src":require("@/assets/youpaq-logo-home.png")}}),_c('span',[_vm._v("by")]),_c('img',{staticClass:"shopLogo",attrs:{"src":require("@/assets/youpaq-nestle-logo-home.png")}})])])
}]

export { render, staticRenderFns }